
import * as React from "react";
import {Fragment} from "react";

import {LoadingSpinner} from "../util/LoadingSpinner";
import {RouteComponentProps} from "react-router";
import {toPathParams} from "../util/UrlUtils";


export interface LoadingViewState {
    loading? : boolean;
    loadingFailed? : boolean;
    initialized? : boolean;
    errorMessage? : string;
    errorStatus? : number;
}
export abstract class RouterView<P extends RouteComponentProps,S extends LoadingViewState> extends React.Component<P, S> {

    

    componentDidMount() {
        this.refreshContent();
    }
    refreshContent() {
        this.setState({ loading : true } as any);
        let promise = this.loadContent() as Promise<any> ;
        if(promise) {
            promise.then(()=>{
                setTimeout(()=>this.setState({loading : false, initialized : true} as any),0);
            }).catch( err => {
                setTimeout(()=>  this.setState({loading : false, loadingFailed : true, errorMessage: err.message, errorStatus: err.status} as any));
            });
        } else {
            setTimeout(()=>this.setState({loading : false} as any),0);
        }
    }
    abstract loadContent() : Promise<any> | void;

    abstract getTitle() : string;

    getSubTitle(){ return ""; }

    componentDidUpdate(prevProps : P, prevState : S) {

    }
    componentWillUnmount() {

    }

    navigate ( path : string) {
        this.props.history.push(path);
    }

    setLoading(loading : boolean){
        this.setState({loading : loading, loadingFailed : false});

    }
    setErrorLoading() {
        this.setState({loading : false, loadingFailed : true});
    }

    load<L>(p : Promise<L>) : Promise<L> {
        this.setLoading(true);
        var promise = new Promise<L>((resolve,reject)=>{
            p.then((res : L)=>{
                resolve(res);
            }).catch((err)=>{
                reject(err);
                console.log("ERROR LOADING", err);
                this.setErrorLoading();
            });
        });
        return promise;
    }

    toPathParams(target : any) : string {
      return toPathParams(target);
    }
    updatePathParams(base : string, target : any) {
        let params = this.toPathParams(target);
        this.navigate(base + params);
    }
    abstract renderContent() : JSX.Element;

    isShowContentWhenOnRefresh() : boolean{
        return false;
    }

    render() {
        let showLoading = this.state.loading;
        if(this.isShowContentWhenOnRefresh() === true && this.state.initialized === true) {
            showLoading = false;
        }
        if(this.state.loadingFailed === true) {
               return (
                   <div className="wrapper wrapper-content animated">
                       <div className="middle-box text-center fadeInDown">
                           <h1>{this.state.errorStatus===null ? 500 :this.state.errorStatus }</h1>
                           <h2 className="font-bold danger">{this.state.errorMessage===null ? "Something went wrong...":this.state.errorMessage}</h2>

                           <div className="error-desc">
                                Try reloading, if the error persists please contact support
                           </div>
                       </div>
                   </div>
               );
        } else if(showLoading === true) {
            return (
                <div className="wrapper wrapper-content animated">
                    <div className="row">
                        <div className="col-lg-12 loading-content">
                            <LoadingSpinner />
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
               <Fragment>
                   <div className="row">
                       <div className="col-12">
                           <div className="page-title-box">
                               <div className="page-title-right">
                                    {this.getSubTitle()}
                               </div>
                               <h4 className="page-title">{this.getTitle()}</h4>
                           </div>
                       </div>
                   </div>
                   {this.renderContent()}
               </Fragment>
            )

        }
    }

}